// Libs
import classNames from 'classnames/bind';
import { Avatar, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { IBaseUser } from '~/utils/interface/common';
import { EMPTY_STRING } from '~/utils/constants/common';
import { getFullName, getInitials } from '~/utils/helper/common';
// Styles, images, icons
import styles from './BaseTableUser.module.scss';

type Props = {
  user: IBaseUser;
  onClick?: (id: string) => void;
};

const cx = classNames.bind(styles);

const BaseTableUser = (props: Props) => {
  //#region Destructuring Props
  const { user, onClick } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      gap={'6px'}
      component={'div'}
      id='baseTableUserComponent'
      className={cx('container', { click: onClick })}
      {...(user?.id && onClick && { onClick: () => onClick(user?.id as string) })}
    >
      {user?.avatar ? (
        <Avatar src={user?.avatar} alt={t('common_alt_img')} className={cx('avatar')} />
      ) : (
        <Avatar src={user?.avatar} alt={t('common_alt_img')} className={cx('avatar')}>
          <Typography className={cx('avatarUserName')}>
            {getInitials({ firstName: user?.firstName, lastName: user?.lastName })}
          </Typography>
        </Avatar>
      )}

      {getFullName(user) !== EMPTY_STRING && (
        <Typography className={cx('userName')}>{getFullName(user)}</Typography>
      )}
    </Stack>
  );
};

export default BaseTableUser;
